module.exports = __webpack_public_path__ + "static/img/13.71d7d14.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/sp/13.png
// module id = 1Y5P
// module chunks = 0